"use client";

import React from "react";
import { useRealtime } from "@/hooks/use-realtime";
import { cn } from "@/lib/utils/cn";

interface RealtimeIndicatorProps {
  channel: string;
  onEvent?: (event: { type: string; payload: unknown }) => void;
}

export function RealtimeIndicator({ channel, onEvent }: RealtimeIndicatorProps) {
  const { isConnected } = useRealtime({
    channel,
    onEvent,
    enabled: true,
  });

  return (
    <div
      className={cn(
        "flex items-center gap-1.5 text-xs",
        isConnected ? "text-green-500" : "text-muted-foreground"
      )}
    >
      <span
        className={cn(
          "h-2 w-2 rounded-full",
          isConnected ? "bg-green-500 animate-pulse" : "bg-muted"
        )}
      />
      {isConnected ? "Live" : "Offline"}
    </div>
  );
}
